import { render, staticRenderFns } from "./PhotoViewer.vue?vue&type=template&id=ea99a12a&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"
import style0 from "./PhotoViewer.vue?vue&type=style&index=0&id=ea99a12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea99a12a",
  null
  
)

export default component.exports